module.exports = __webpack_public_path__ + "img/22-small.2548b8fd.png";